import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { DotComponent, ChipComponent } from 'shared/ui-common';

@Component({
  selector: 'tt-resource-tag-chip',
  standalone: true,
  imports: [ChipComponent, DotComponent],
  templateUrl: './resource-tag-chip.component.html',
  styleUrls: ['./resource-tag-chip.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-testid]': '"tt-resource-tag-chip--" + label()',
  },
})
export class ResourceTagChipComponent {
  public label = input<string>('');
  public customColor = input<string>();
  public customBackgroundColor = input<string>();
  public clickable = input<boolean>(false);
}
